module.exports = __webpack_public_path__ + "media/images/category_icons/category_icon_3-2a80d63c1a6249465cd4a28ad60b01e8.svg";